/**
 * Policy Hub API surface. Each function wraps a single backend endpoint —
 * calling code stays unaware of URL shapes and query params.
 *
 * Response envelopes match the DRF views exactly:
 *
 *   listPolicies()               -> { results: [meta, ...], can_edit }
 *   fetchPolicy(code)            -> { policy, can_edit }
 *   updatePolicy(code, payload)  -> { policy, can_edit }   // 200 on success
 *   fetchPolicyHistory(code)     -> { results: [log, ...] }
 */
import axiosInstance from "./service-instance";

export const listPolicies = () =>
    axiosInstance.get("/policy-hub/policies/");

export const fetchPolicy = code =>
    axiosInstance.get(`/policy-hub/policies/${encodeURIComponent(code)}/`);

// `payload` may include: content (required), schema (optional), description (optional), note (optional).
export const updatePolicy = (code, payload) =>
    axiosInstance.put(
        `/policy-hub/policies/${encodeURIComponent(code)}/`,
        payload
    );

export const fetchPolicyHistory = code =>
    axiosInstance.get(
        `/policy-hub/policies/${encodeURIComponent(code)}/history/`
    );
